import { render, staticRenderFns } from "./VideojsVHS.vue?vue&type=template&id=66e22bfb&scoped=true&"
import script from "./VideojsVHS.vue?vue&type=script&lang=js&"
export * from "./VideojsVHS.vue?vue&type=script&lang=js&"
import style0 from "./VideojsVHS.vue?vue&type=style&index=0&id=66e22bfb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e22bfb",
  null
  
)

export default component.exports